module.exports = __webpack_public_path__ + "static/media/eval.51710b04.jpg";